export default () => ({
  brands: {
    marginBottom: '2rem',
  },
  tabs__content__container_empty: {
    height: '42.3vh',
  },
});
